import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UploadError } from "../../models/upload-error";
import { PhotoUploadService, SuccessfulUpload } from "@shared/src/public-api";
import { PDFDocument } from "pdf-lib";

export interface FileData {
	formData: FormData;
	isPdf: boolean;
	pageCount: number;
	name: string;
}

@Component({
	selector: "jhm-upload",
	imports: [],
	templateUrl: "./upload.component.html",
	styleUrl: "./upload.component.scss"
})
export class UploadComponent {
	public uploadingFile: boolean = false;
	public uploadError: UploadError;
	@Input() fileUploadPath: string;
	@Input() getFormData: boolean = false;
	@Output() fileUploaded: EventEmitter<SuccessfulUpload> = new EventEmitter<SuccessfulUpload>();
	@Output() fileData: EventEmitter<FileData> = new EventEmitter<FileData>();

	public constructor(private photoUploadService: PhotoUploadService) {
	}

	public formatBytesToMB(number: number): number
	{
		return Math.round(number / 1024000 * 100) / 100;
	}

	public fileSelected(event: any): void
	{
		this.uploadingFile = true;
		if (this.getFormData) {
			const formData: FormData = this.photoUploadService.getFormData(event.target.files);
			const fileInfo: File = event.target.files[0];
			const fileType = fileInfo.type;
			let isPdf = false;
			let pageCount = 0;

			if (fileType === "application/pdf") {
				isPdf = true;
				fileInfo.arrayBuffer().then((arrayBuffer) => {
					PDFDocument.load(arrayBuffer).then((pdfDoc) => {
						pageCount = pdfDoc.getPageCount();
						this.fileData.emit({
							formData: formData,
							isPdf: isPdf,
							pageCount: pageCount,
							name: fileInfo.name
						});
					});
				});
			}
			else {
				this.fileData.emit({
					formData: formData,
					isPdf: isPdf,
					pageCount: 1,
					name: fileInfo.name
				});
			}
		}
		else {
			this.photoUploadService.uploadFiles(event.target.files, this.fileUploadPath)
				.subscribe({
					next: (upload: SuccessfulUpload) =>
					{
						this.fileUploaded.emit(upload);
						this.uploadingFile = false;
						this.uploadError = null;
					},
					error: (error: any) =>
					{
						this.uploadError = error.error;
					}
				});
		}
	}
}
